<template>
    <div
        class="basic-video" 
        :class="[isWebPcMode ? 'basic-video-pc' : '', isEditorPcMode ? 'basic-video-editor' : '']"
        :style="cssVar"
    >
        <div class="main-content">
            <div class="video" ref="video">
                <video ref="videoPlayer" class="video-js" playsinline></video>
            </div>
            <div v-if="showMask" class="mask">
                <template v-if="isWebPcMode">
                    <div v-html="maskFirstTitle"></div>
                    <div v-html="maskSecondTitle" class="mask-two-level-title"></div>
                </template>
                <div v-else v-html="maskTxt"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { MASK_TXT } from '../constants/index.js';
import { isPcMode, isEditor } from '../fego/utils.js';
import 'video.js/dist/video-js.css';
export default {
    name: 'basic-video',
    components: {},
    props: {
        showMask: {
            type: Boolean
        },
        maskTxt: {
            type: String,
            default: MASK_TXT
        },
        maskFirstTitle: {
            type: String,
            default: ''
        },
        maskSecondTitle: {
            type: String,
            default: ''
        },
        showPlayIcon: {
            type: Boolean,
            default: true
        },
        autoPlay: { type: Boolean },
        loop: { type: Boolean },
        controls: { type: Boolean },
        muted: { type: Boolean },
        poster: { type: String },
        videoLink: { type: String },
        triggerPlayTimeSpan: { type: Number, default: 0 }
    },
    data() {
        return {
            isPreRender: window.__PRE_RENDERING__ || location.search.indexOf('pre_rendering') !== -1
        };
    },
    computed: {
        videoOptions() {
            return {
                autoplay: !!this.autoPlay,
                controls: this.controls,
                loop: this.loop,
                poster: this.poster, // 视频封面图地址
                muted: this.muted, // 默认静音播放
                sources: [
                    {
                        src: this.videoLink
                    }
                ],
                suppressNotSupportedError: true // 资源错误不console报错
            };
        },
        cssVar() {
            return {
                '--show-play-icon': this.showPlayIcon ? 'flex' : 'none'
            }
        },
        isWebPcMode() {
            return isPcMode();
        },
        isEditorPcMode() {
            if (this.isWebPcMode && isEditor()) {
                return true;
            }
            return false;
        }
    },
    watch: {},
    methods: {
        async initVideo() {
            const videojs = (await import('video.js')).default; // 异步加载
            this.player = videojs(this.$refs.videoPlayer, this.videoOptions);

            let startPlayTime = new Date();
            let totalPlayTime = 0;
            this.player.on('error', (msg) => {
                console.log(msg);
            });

            this.player.on('play', () => {
                startPlayTime = new Date();
                this.$emit('basic-video_start-play');
            });

            this.player.on('ended', () => {
                this.$emit('basic-video_play-finish');
            });

            let isTriggered = false;
            this.player.on('timeupdate', () => {
                const now = new Date();
                totalPlayTime += now.getTime() - startPlayTime.getTime();
                startPlayTime = now;
                // 只触发一次
                if (!isTriggered && this.triggerPlayTimeSpan && totalPlayTime >= this.triggerPlayTimeSpan * 1000) {
                    this.$emit('basic-video_played-for-duration');
                    isTriggered = true;
                }
            });
        }
    },
    created() {},
    async mounted() {
        if (!this.isPreRender && (this.poster || this.videoLink)) {
            await this.initVideo();
        }
    }
};
</script>
<style lang="less" scoped>
@import '../common/videoSkin.less';

.basic-video {
    position: relative;

    .main-content {
        position: relative;
        height: 100%;
        width: 100%;
    }

    .mask {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        padding: 0 0.4rem 0.7rem 0.4rem;
        background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(112, 112, 112, 0.63) 70.31%,
            rgba(0, 0, 0, 0.7) 100%
        );
        display: flex;
        align-items: flex-end;
        pointer-events: none;
    }

    .video {
        width: 100%;
        height: 100%;

        .video-js {
            width: 100%;
            height: 100%;
        }
    }
}

.basic-video-pc {
    display: flex;
    justify-content: center;

    .mask {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        text-align: center;
        border-radius: 0.4rem 0.4rem 0 0;

        .mask-two-level-title {
            margin-top: 0.2rem;
        }
    }
}
</style>
